
/*
 * Copyright (c) Aista Ltd, and Thomas Hansen - For license inquiries you can contact thomas@ainiro.io.
 */
export const environment = {
  production: false,
  defaultBackends: [
    {
      url: 'http://localhost:5000',
      username: 'root',
      password: 'root',
      token_raw: null,
    },
  ],
  bazarUrl: 'https://api.aista.com'
};
